<template>
  <div>
    <v-container style="height: 400px;">
      <v-card class="mx-auto" max-width="600" elevation="10">
        <v-row class="fill-height" align-content="center" justify="center" >
          <v-col class="title text-center" cols="12">
            {{ $t('message.common.loadingMsg') }}...
          </v-col>
           <v-col class="title text-center" cols="12">
            Checking <kbd>Auth Token</kbd> from SuperOffice...
          </v-col>
          <v-col cols="6" class="text-center">
            <v-progress-circular :size="70" :width="7" color="primary" class="mx-auto" indeterminate></v-progress-circular>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.$store.commit('clearSession')
    if (this.$route && this.$route.query.jwt) {
      // eslint-disable-next-line camelcase
      let { jwt, id, name, so_userid, is_admin } = this.$route.query
      // eslint-disable-next-line camelcase
      let model = { token: jwt, id, name, so_user_id: so_userid, isadmin: is_admin, isClient: true } // : is_admin === 'true'
      this.$store.dispatch('login', model)
        .then(() => {
          this.$router.push({ path: this.$route.query.redirect || 'dashboard' })
        })
    }
  }
}
</script>
